// import { logger } from '@marriott/mi-headless-utils';
// const { log } = logger({})('CookieUtils.ts');

// store cookies in a module-level variable
let cookiesCache: Record<string, string> = {};

/**
 * Parse and cache all cookies from document.cookie
 */
export const setCookies = (): void => {
  const cookieString = document?.cookie || '';
  cookiesCache = {};

  cookieString.split(';').forEach(cookie => {
    const [key, value] = cookie.trim().split('=');
    if (key && value) {
      try {
        cookiesCache[key] = decodeURIComponent(value);
      } catch (error) {
        cookiesCache[key] = value;
        // log.error(`Cookie ${key} with value ${value} could not be decoded - Error ${error}`);
      }
    }
  });
};

/**
 * Get a cookie value by name
 * @param cookieName Name of the cookie to retrieve
 * @returns The cookie value or empty string if not found
 */
export const getCookie = (cookieName: string): string => {
  if (Object.keys(cookiesCache).length === 0) {
    setCookies();
  }
  return cookiesCache[cookieName] || '';
};

// Export default for backward compatibility
const CookieUtils = {
  getCookie,
  setCookies,
};

export default CookieUtils;
